import React from 'react'
import * as st from '~/assets/styl/Designers.module.styl'
import { Lazyload } from '~/components'
import bg from '~/assets/img/projetistas-planta.webp'
import { useLanguage } from '~/hooks'

export default function Designers() {
  const { t } = useLanguage()
  return (
    <section className={st.core} id="Projetistas">
      <div>
        <h2>
          <span>{t('Designers.title')}</span>
        </h2>
        <Lazyload src={bg} className={st.bg} />
      </div>
      <div>
        <ul>
          <li>
            <strong>{t('Designers.structural')}</strong>
            Esteng
          </li>
          <li>
            <strong>{t('Designers.interiorDesign')}</strong>
            Desterro Arquitetos
          </li>
          <li>
            <strong>{t('Designers.Conditioning')}</strong>
            Beck & Falk
          </li>
          <li>
            <strong>{t('Designers.frames')}</strong>
            WM
          </li>
          <li>
            <strong>{t('Designers.hydrosanitary')}</strong>
            Première Engenharia
          </li>
          <li>
            <strong>{t('Designers.electric')}</strong>
            Lippel Engenharia
          </li>
          <li>
            <strong>{t('Designers.acousticsProject')}</strong>
            Pablo Serrano - Soluções Acústicas
          </li>
          <li>
            <strong>{t('Designers.architecture')}</strong>
            Methafora Arquitetos
          </li>
          <li>
            <strong>{t('Designers.landscaping')}</strong>
            Terraço Paisagismo
          </li>
          <li>
            <strong>{t('Designers.irrigation')}</strong>
            Grupo Le Notre
          </li>
        </ul>
      </div>
    </section>
  )
}
